import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Test from "../views/Test.vue";
import Privacy from "../views/Privacy.vue";
import VIP from "../views/VIP.vue";
import Configs from "../views/Configs.vue";
import AdsApply from "../views/AdsApply.vue";
import AdsThank from "../views/AdsThank.vue";
import Station from "../views/dashboard/Station.vue";
import Trend from "../views/dashboard/Trend.vue";
import AdsDashboard from "../views/dashboard/Ads.vue";
import AdsReport from "../views/dashboard/AdsReport.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/test",
    name: "Test",
    component: Test,
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy,
  },
  {
    path: "/dashboard/station",
    name: "Station",
    component: Station,
  },
  {
    path: "/dashboard/trend",
    name: "Trend",
    component: Trend,
  },
  {
    path: "/dashboard/ads",
    name: "AdsDashboard",
    component: AdsDashboard,
  },
  {
    path: "/dashboard/ads/report",
    name: "AdsReport",
    component: AdsReport,
  },
  {
    path: "/vip",
    name: "VIP",
    component: VIP,
  },
  {
    path: "/configs",
    name: "Configs",
    component: Configs,
  },
  {
    path: "/ads",
    name: "AdsApply",
    component: AdsApply,
  },
  {
    path: "/ads/thank",
    name: "AdsThank",
    component: AdsThank,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
